import axios from 'axios';
import UrlsUtil from '../../utils/url.util';

const apiBaseUrl = UrlsUtil.determineApiBaseUrl(window);
const apiPageUrl = `${apiBaseUrl}/api/home`
const apiKey = `${process.env.REACT_APP_APIKEY}`;

export default class HomeService {
  static getVersion = async (): Promise<any> => {
    const url = `${apiPageUrl}/version`;
    return await axios.get(url);
  };

  static login = async (username: string, password: string): Promise<any> => {
    const url = `${apiPageUrl}`;
    const payload = {
      username: username,
      password: password
    }; 
    return await axios.post(url, payload, { headers: { 'apiKey': apiKey } });
  };
};